import { z } from 'zod';

export const contactTableFiltersSchema = z.object({
  //fullName: z.string().optional(), we dont have the fullName no more
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNumber: z.string().optional(),
  email: z.string().optional(),
  hasSignedContracts: z
    .boolean()
    .optional()
    .describe(
      'Indicate if the contacts has at least 1 contract with the signed status. This check on the contracts table.',
    ),
  language: z
    .string()
    .optional()
    .describe(
      'Indicate the language of the contact. This check contact_languages table.',
    ),
  salesRepId: z
    .string()
    .optional()
    .describe('Sales Rep ID - Its the ID on the users table'),
  hasPayments: z
    .boolean()
    .optional()
    .describe(
      'Indicate if the contacts has at least 1 payment. This check on the payments table.',
    ),
  lastCommunicationDateRange: z.array(z.string()).length(2).optional(),
  oldSystemId: z
    .number()
    .optional()
    .describe(
      'Indicate the old system ID of the contact. This check on the contacts table.',
    ),
});

export type ContactTableFilter = z.infer<typeof contactTableFiltersSchema>;

/*

export const contractDataSchema = z.object({
  name: z.string().min(2, 'Contract name must be at least 2 characters'),
  firstName: z.string().min(2, 'First name must be at least 2 characters'),
  lastName: z.string().min(0, 'Last name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  phoneNumber: z
    .string()
    .min(10, 'Phone number must be at least 10 characters'),
  surgeonId: z.string(),
  procedures: selectedItemSchema.array(),
  products: selectedItemSchema.array(),
  totalCost: z.number().optional(),
});

*/
